import React, { Component } from 'react';
import './CheckBox.css';
import FontIcon from '../../components/fontIcon/FontIcon';

export default class CheckBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.defaultValue()
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.isBooleanValue(nextProps.forceValue)) {
			this.setState({ value: nextProps.forceValue });
		} else if (this.isBooleanValue(nextProps.value)) {
			this.setState({ value: nextProps.value });
		}
	}

	defaultValue = () => {
		if (this.isBooleanValue(this.props.forceValue)) {
			return this.props.forceValue;
		} else if (this.isBooleanValue(this.props.value)) {
			return this.props.value;
		}
		return false;
	};

	isBooleanValue = (value) => {
		if (value === !!value) {
			return true;
		}
		return false;
	};

	getValue = () => {
		return this.state.value;
	};

	isValid = () => {
		if (this.props.required && !this.state.value) {
			return false;
		}
		return true;
	};

	_isEmpty = (value) => {
		if (value === null) return true;
		if (value === undefined) return true;
		if (value === '') return true;
		return false;
	};

	_getClasses = () => {
		let classes = 'g-check-box';
		if (this.props.className) {
			classes += ' ' + this.props.className;
		}
		return classes;
	};

	_onChange = (e) => {
		let value = !this.state.value;
		if (!this.props.disabled) {
			this.setState({ value }, () => {
				if (this.props.onChange && typeof this.props.onChange === 'function') {
					this.props.onChange(value);
				}
			});
		}
	};
	getCheckbox = () => {
		const {onClick} = this.props
		let checkbox = (
			<input
				
				onClick={onClick || this._onChange}
				onTouchEnd={this._onChange}
				ref={(ref) => (this.checkbox = ref)}
				type="checkbox"
				checked={!!this.state.value}
			/>
		);
		if (this.props.disabled) {
			checkbox = <input disabled ref={(ref) => (this.checkbox = ref)} type="checkbox" checked={!!this.state.value} />;
		}
		return checkbox;
	};

	render() {
		const otherProps = {}
		if('tabIndex' in this.props) {
			otherProps.tabIndex = "0";
		}
		let requiredMessage = '';
		// if (this.state.showRequired) {
		//   requiredMessage = (
		//     <InputValidationError showRequiredText={this.state.showRequired} className={classes} />
		//   );
		// }
		return (
			<div className={this._getClasses()}>
				<label>
					{this.getCheckbox()}
					<FontIcon {...otherProps} name="icon-check" />
				</label>
				{requiredMessage}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/inputs/checkBox/CheckBox.jsx